"use client";

import {FormControl, FormField, FormItem, FormLabel} from "@/components/ui/form";
import {Switch} from "@/components/ui/switch";
import {cn} from "@/lib/utils";

export default function CWFSwitch({control, name, className, label, ...props}) {
    return(
        <FormField control={control}
                   name={name}
                   render={({field})=>(
                       <FormItem className={cn("flex flex-col items-center",className)}>
                           <div className={"space-y-0.5"}>
                               <FormLabel>{label}</FormLabel>
                           </div>
                           <FormControl>
                               <Switch checked={field.value} onCheckedChange={field.onChange} {...props}/>
                           </FormControl>
                       </FormItem>

                   )}
        />
    )
}